
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import Logo from "@/icons/Logo";
import PremiumLoginForm from "@/components/premium-auth/PremiumLoginForm";
import { supabase } from "@/integrations/supabase/client";

const PREMIUM_RESET_SLUG_STORAGE_KEY = 'premium-reset-slug';

const Index = () => {
  const navigate = useNavigate();
  const [checkingAuth, setCheckingAuth] = useState(true);

  useEffect(() => {
    // Handle password recovery hash redirect
    const hash = window.location.hash;
    if (hash) {
      const hashParams = new URLSearchParams(hash.substring(1));
      if (hashParams.get('type') === 'recovery') {
        let storedSlug = '';
        try {
          storedSlug = localStorage.getItem(PREMIUM_RESET_SLUG_STORAGE_KEY)?.trim() || '';
        } catch {
          // ignore storage errors
        }
        const slugQuery = storedSlug ? `?slug=${encodeURIComponent(storedSlug)}` : '';
        navigate(`/premium-reset-password${slugQuery}${hash}`, { replace: true });
        return;
      }
    }

    // Check if already authenticated as org member
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.user) {
        const { data: orgMember } = await supabase
          .from('organization_members')
          .select('id')
          .eq('id', session.user.id)
          .maybeSingle();

        if (orgMember) {
          navigate('/premium', { replace: true });
          return;
        }
      }
      setCheckingAuth(false);
    };

    checkSession();
  }, [navigate]);

  const handleAuthSuccess = async () => {
    // Verify org membership before redirecting
    const { data: { user } } = await supabase.auth.getUser();
    if (user) {
      const { data: orgMember } = await supabase
        .from('organization_members')
        .select('id')
        .eq('id', user.id)
        .maybeSingle();

      if (orgMember) {
        navigate('/premium');
        return;
      }
    }
    // If not an org member, stay on login page
  };

  if (checkingAuth) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-muted/30">
        <div className="flex items-center gap-3">
          <Logo className="h-8 w-8" />
          <span className="text-lg text-foreground">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-muted p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1 text-center">
          <div className="flex justify-center mb-2">
            <Logo className="h-10 w-10" />
          </div>
          <CardTitle className="text-2xl font-bold">
            Maturity Compass
          </CardTitle>
          <CardDescription>
            Sign in to access Maturity Compass.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <PremiumLoginForm onSuccess={handleAuthSuccess} />
        </CardContent>
      </Card>
    </div>
  );
};

export default Index;
